import { Theme, } from '@material-ui/core/styles';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import colors from '../../../utils/colors';

// @todo remove this file when time allows

export const classes: (theme: Theme) => Record<string, CSSProperties> = (theme: Theme) => ({
	filter: {
		background: colors.lightGrey,
	},
	table: {
	},
	imagePreview: {
		maxHeight: 46,
	},
	deleteClass: {
		color: theme.palette.primary.main,
	},
	selectRoot: {
		minWidth: 200,
	},
	filterNameRoot: {
		minWidth: 200,
	},
	gap: {
		marginRight: 10,
	},
	noRecord: {
		'textAlign': 'center',
		padding: 10,
	},
	tableHeaderCell: {
		fontSize: '1rem',
		fontWeight: 600,
		color: 'black',
	},
	tableBodyCell: {
		fontSize: '1rem',
	},
	imageCell: {
		textAlign: 'center',
	},
	tableRow: {
		cursor: 'pointer'
	}
});
